<ng-container *ngIf="!readonly">
  <mat-checkbox
    [required]="fgInfo.required"
    [formControl]="formControl"
    (change)="change.next($event)"
    [ngClass]="{ 'allow-pointer': tooltipText }"
    class="app-checkbox"
  >
    <span [class]="hideLabel ? 'visually-hidden' : ''">
      {{ labelOverride || fgInfo?.label
      }}{{ formControl['condrequired'] || fgInfo?.requiredTrue ? '*' : '' }}
    </span>
    <mat-icon
      *ngIf="!hideLabel"
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-checkbox>
  <div class="checkbox-error mat-hint" *ngIf="hint && (!formControl.touched || formControl.valid)">
    {{ hint }}
  </div>
  <div class="checkbox-error mat-error" *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    [floatLabel]="'always'"
    [ngClass]="{ 'read-only': readonly, 'allow-pointer': tooltipText }"
  >
    <mat-label *ngIf="!hideLabel">
      {{ labelOverride || fgInfo.label }}
      <mat-icon
        [hidden]="!tooltipText"
        [matTooltip]="tooltipText"
        [matTooltipPosition]="'after'"
        [attr.aria-label]="'Tooltip: ' + tooltipText"
        tabindex="0"
      >
        help
      </mat-icon>
    </mat-label>
    <input
      readonly
      matInput
      [value]="formControl.value == true ? 'Yes' : hideReadOnlyNo ? '' : 'No'"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
